import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appCurrencyMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyMaskDirective),
      multi: true,
    },
  ],
})
export class CurrencyMaskDirective implements ControlValueAccessor {
  private onChange: (value: number | null) => void = () => {};
  private onTouched: () => void = () => {};
  private _value: number | null = null;
  private decimalSeparator = ',';
  private thousandSeparator = '.';
  private currencySuffix = ' €';

  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = this.el.nativeElement;
    let value = input.value;

    let cleanValue = value.replace(/[^\d,]/g, '');

    if (cleanValue === '') {
      this._value = null;
      this.onChange(null);
      input.value = '';
      return;
    }

    const parts = cleanValue.split(this.decimalSeparator);
    if (parts.length > 2) {
      cleanValue = parts[0] + this.decimalSeparator + parts.slice(1).join('');
    }

    const normalized = cleanValue.replace(this.decimalSeparator, '.');
    const num = parseFloat(normalized);
    if (!isNaN(num)) {
      this._value = num;
      this.onChange(num);
    } else {
      this._value = null;
      this.onChange(null);
    }

    input.value = cleanValue;
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
    const input = this.el.nativeElement;

    if (!input.value || input.value.trim() === '') {
      this._value = 0;
      this.onChange(0);
    }
    this.formatInput();
  }

  @HostListener('focus')
  onFocus() {
    const input = this.el.nativeElement;
    this._value = null;
    this.onChange(null);
    input.value = '';
  }

  writeValue(value: number | null): void {
    this._value = value;
    this.formatInput();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  private formatInput() {
    let value = this._value;
    const input = this.el.nativeElement;
    if (value === null || value === undefined || isNaN(value)) {
      input.value = '';
      return;
    }

    const parts = value.toFixed(2).split('.');
    let integer = parts[0];
    const decimal = parts[1];
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandSeparator);
    const formatted = `${integer}${this.decimalSeparator}${decimal}${this.currencySuffix}`;
    input.value = formatted;
  }
}
